const ExitIcon = ({
  width = 24,
  height = 24,
  color = "currentColor",
  strokeWidth = 40,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 682.667 682.667"
    {...props}
  >
    <defs>
      <clipPath id="exitClip">
        <path d="M0 512h512V0H0Z" />
      </clipPath>
    </defs>

    <g
      transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
      clipPath="url(#exitClip)"
    >
      <path
        d="M0 0v-40c0-33.137-26.863-60-60-60h-201c-33.137 0-60 26.863-60 60v352c0 33.137 26.863 60 60 60h201c33.137 0 60-26.863 60-60v-40"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(341 120)"
      />
      <path
        d="M0 0h-271"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(487 255)"
      />
      <path
        d="m0 0 44.786 44.787c11.716 11.716 11.716 30.71 0 42.426L0 132"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(438.427 189)"
      />
    </g>
  </svg>
);

export default ExitIcon;
